export default class Toast {

  constructor(elem) {
    this.container = elem;
    this.items = this.container.querySelectorAll('.js-toast');

    this.duration = 7000 // css animation

    this.showOnLoad = this.showOnLoad.bind(this);
    this.openToast = this.openToast.bind(this);
    this.closeToast = this.closeToast.bind(this);

    if (this.items.length) {
      this.showOnLoad();
    }
  }

  showOnLoad() {
    for (let i = 0; i < this.items.length; i++) {
      const element = this.items[i];
      this.openToast(element);
    }
  }

  openToast(toast) {
    toast.classList.add('is--visible');
    const closeBtn = toast.querySelector('.js-toast-close');

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeToast(toast));
    }

    const self = this;
    setTimeout(function () {
      self.closeToast(toast)
    }, this.duration);
  }

  closeToast(toast) {
    toast.classList.remove('is--visible');

    setTimeout(function () {
      toast.remove();
    }, 500);
  }
}